<!-- 新增编辑框 -->
<template>
  <a-modal
    :title="title"
    width="1000px"
    :visible="visible"
    @ok="onSave"
    @cancel="onClose"
    v-if="visible"
  >
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :colon="false"
      class="drawer-view"
    >
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="应用简称" prop="appShortName">
            <InputText v-model="ruleForm.appShortName" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="系统名称" prop="appName">
            <InputText v-model="ruleForm.appName" allowClear />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="访问地址" prop="appLoginUrl">
            <InputText v-model="ruleForm.appLoginUrl" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="系统登出地址" prop="appLogoutUrl">
            <InputText v-model="ruleForm.appLogoutUrl" allowClear />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="签名密钥">
            <InputText v-model="ruleForm.signatureKey" disabled allowClear />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="加密密钥">
            <InputText v-model="ruleForm.encryptionKey" disabled allowClear />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col span="12">
          <a-form-model-item label="排序" prop="sortValue">
            <InputText v-model="ruleForm.sortValue" allowClear />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="状态" prop="dataStatus">
            <SelectModule
              v-model="ruleForm.dataStatus"
              apiType="getDictDataByCode"
              :apiParams="{ dictCode: 'app_status' }"
              :showAll="true"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import InputText from "@/components/form/InputText"; // 输入框组建
import SelectModule from "@/components/form/SelectModule"; // 下拉组件
import API from "@/api/application.js"; // 请求接口
export default {
  components: {
    InputText,
    SelectModule,
  },
  props: {
    // 表格选中数据
    modalData: {
      type: Object,
      required: false,
    },
    modalFlag: Boolean,
  },
  computed: {
    title() {
      let str = "";
      if (JSON.stringify(this.modalData) != "{}") {
        str = "编辑";
      } else {
        str = "新增";
      }
      return str;
    },
  },
  data() {
    const checkSfz = (rule, value, callback) => {
      let reg = /^[1-9][0-9]*$/;
      // 校验身份证
      if (value === "") {
        callback(new Error("请输入排序序号!"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正整数"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        id: "", // 主键ID
        appShortName: "",
        appName: "",
        appLoginUrl: "",
        appLogoutUrl: "",
        signatureKey: "",
        encryptionKey: "",
        sortValue: "",
        dataStatus: "",
      },
      rules: {
        appShortName: [
          { required: true, message: "请输入应用简称!", trigger: "change" },
        ],
        appName: [
          { required: true, message: "请输入系统名称!", trigger: "change" },
        ],
        appLoginUrl: [
          { required: true, message: "请输入访问地址!", trigger: "change" },
        ],
        appLogoutUrl: [
          { required: true, message: "请输入登出地址!", trigger: "change" },
        ],
        // signatureKey: [
        //   { required: true, message: "请输入签名密钥!", trigger: "change" },
        // ],
        // encryptionKey: [
        //   { required: true, message: "请输入加密密钥!", trigger: "change" },
        // ],
        sortValue: [
          { required: true, validator: checkSfz, trigger: "change" },
        ],
        dataStatus: [
          { required: true, message: "请选择状态!", trigger: "change" },
        ],
      },
      visible: false,
    };
  },
  methods: {
    // 关闭
    onClose() {
      this.$emit("handleFlag", false);
    },
    // 获取角色详情
    getDetail() {
      let params = {
        data: {
          params: {
            id: this.ruleForm.id,
          },
        },
      };
      API.getAppManageInfo(params, (callback) => {
        let data = {};
        if (callback.status == "S" && callback.data) {
          data = callback.data;
          for (let key in this.ruleForm) {
            if (data.hasOwnProperty(key)) {
              if (key == "sortValue" || key == "dataStatus") {
                this.ruleForm[key] = data[key].toString() || "";
              } else {
                this.ruleForm[key] = data[key] || "";
              }
            }
          }
        }
      });
    },

    // 保存
    onSave() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submit();
        }
      });
    },
    submit() {
      this.loading = true;
      let params = {
        data: {
          params: {
            // id: this.modalData.id || "",
            ...this.ruleForm,
            dataStatus: Number(this.ruleForm.dataStatus),
            sortValue: Number(this.ruleForm.sortValue) || "",
          },
        },
      };
      API.saveAppManageInfo(params, (callback) => {
        this.loading = false;
        if (callback.status == "S") {
          let str = "";
          if (JSON.stringify(this.modalData) != "{}") {
            str = "编辑";
          } else {
            str = "新增";
          }
          this.$message.destroy();
          this.$message.success(`${str}成功`);
          this.$emit("handleFlag", false, {}, "ok");
        }
      });
    },
  },
  watch: {
    // 模态框开关
    modalFlag(newVal, oldVal) {
      this.visible = newVal;
      if (newVal) {
        this.ruleForm.id = this.modalData.id || "";
        if (JSON.stringify(this.modalData) != "{}") {
          // 编辑
          this.getDetail();
        }
      } else {
        this.ruleForm = {
          id: "", // 主键ID
          appShortName: "",
          appName: "",
          appLoginUrl: "",
          appLogoutUrl: "",
          signatureKey: "",
          encryptionKey: "",
          sortValue: "",
          dataStatus: "",
        };
      }
    },
  },
};
</script>
